export const BACKEND_PERSONAL_INFO_KEY = 'PersonalInfo';
export const BACKEND_EDUCATION_LIST_KEY = 'EducationTypeOptions';
export const BACKEND_EDUCATION_GOALS_KEY = 'EducationGoals';
export const BACKEND_EDUCATION_GOAL_API = 'EducationGoal';
export const OTHER_TUITION = 5;

export const DEPENDENT_TYPES = {
  Child: 0,
  Parent: 1,
  GrandParent: 2,
  Spouse: 3,
  Joint: 4,
  Grandchild: 5,
  OtherDependent: 6,
  Charity: 7,
  OtherBeneficiary: 8,
  OtherIndividual: 9,
};
